import { createIcon } from "@chakra-ui/icons";

// Created from cpu.svg

export const CPUIcon = createIcon({
  displayName: "CPU",
  viewBox: "0 0 22 24",
  path: (
    <g id="cpu">
      <rect x="4" y="4" width="16" height="16" rx="2" ry="2" fill="none" stroke="currentColor" />
      <rect x="9" y="9" width="6" height="6" fill="none" stroke="currentColor" />
      <line x1="9" y1="1" x2="9" y2="4" fill="none" stroke="currentColor" />
      <line x1="15" y1="1" x2="15" y2="4" fill="none" stroke="currentColor" />
      <line x1="9" y1="20" x2="9" y2="23" fill="none" stroke="currentColor" />
      <line x1="15" y1="20" x2="15" y2="23" fill="none" stroke="currentColor" />
      <line x1="20" y1="9" x2="23" y2="9" fill="none" stroke="currentColor" />
      <line x1="20" y1="14" x2="23" y2="14" fill="none" stroke="currentColor" />
      <line x1="1" y1="9" x2="4" y2="9" fill="none" stroke="currentColor" />
      <line x1="1" y1="14" x2="4" y2="14" fill="none" stroke="currentColor" />
    </g>
  ),
});
